/** One native field supports paste, autofill, selection and mobile deletion. */
export function CodeInput({ value, onChange, onComplete, disabled, length = 6 }: {
  value: string;
  onChange: (next: string) => void;
  onComplete?: (code: string) => void;
  disabled?: boolean;
  length?: number;
}) {
  return (
    <div className="code-entry">
      <input
        className="code-native"
        aria-label="Code aus der E-Mail"
        type="text"
        inputMode="numeric"
        autoComplete="one-time-code"
        autoFocus
        maxLength={length}
        disabled={disabled}
        value={value}
        onChange={(event) => {
          const next = event.target.value.replace(/\D/g, "").slice(0, length);
          onChange(next);
          if (next.length === length && next !== value) onComplete?.(next);
        }}
        onPaste={(event) => {
          event.preventDefault();
          const next = event.clipboardData.getData("text").replace(/\D/g, "").slice(0, length);
          onChange(next);
          if (next.length === length && next !== value) onComplete?.(next);
        }}
        onKeyDown={(event) => {
          if (event.key === "Enter" && value.length === length && !disabled) onComplete?.(value);
        }}
      />
      <div className="code-boxes" aria-hidden="true">
        {Array.from({ length }, (_, index) => (
          <span key={index} className={"code-box" + (value[index] ? " filled" : "")}>{value[index] ?? ""}</span>
        ))}
      </div>
    </div>
  );
}
